import React from "react";

const SvgDeleteAccount = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M2.5 17.5007V16.6673C2.5 14.8264 3.99238 13.334 5.83333 13.334H9.16667C11.0076 13.334 12.5 14.8264 12.5 16.6673V17.5007"
      stroke="#0C0324"
      strokeLinecap="round"
    />
    <path
      d="M7.5 10.834C6.11929 10.834 5 9.71473 5 8.33398C5 6.95328 6.11929 5.83398 7.5 5.83398C8.88075 5.83398 10 6.95328 10 8.33398C10 9.71473 8.88075 10.834 7.5 10.834Z"
      stroke="#0C0324"
      strokeLinecap="round"
    />
    <path d="M12.5 2.5L17.5 7.5" stroke="#0C0324" strokeLinecap="round" />
    <path d="M17.5 2.5L12.5 7.5" stroke="#0C0324" strokeLinecap="round" />
  </svg>
);

export default SvgDeleteAccount;
